const SalesmanList = () => import('@/pages/business-manage/SalesmanList');
const SalesmanDetail = () => import('@/pages/business-manage/SalesmanDetail');


export default[
    {
      path: '/salesman-list',
      component: SalesmanList,
      meta: [
        {
          name: '业务管理',
          url: '/salesman-list',
        },
        {
          name: '业务员列表',
          url: '/salesman-list',
        },
      ],
    },
    {
      path: '/salesman-list/salesman-detail',
      component: SalesmanDetail,
      meta: [
        {
          name: '业务管理',
          url: '/salesman-list',
        },
        {
          name: '业务员列表',
          url: '/salesman-list',
        },
        {
          name: '业务员详情',
          url: '',
        },
      ],
    },
]
